.column {
  display: flex;
  flex-direction: column;
  position: relative;
}

.scrollableColumns {
  max-width: 100%;
  overflow-x: scroll;
  flex: 1;
  display: flex;
  flex-direction: row;
}

.scoreColumn {
  composes: column;
}

.scoreLeftColumn {
  composes: scoreColumn;
  border-right: 1px solid lightgrey;
}

.scoreColumn>div {
  text-align: center;
  text-wrap: nowrap;
  padding: 4px;
  min-height: 20px;
}

.row {
  display: flex;
  flex-direction: row;
}